export default __webpack_public_path__ + "static/intro-1cb9bdc66d82a79f8f32c506530f6f87.mp4";